<div class="monitor-dashboard-section-shell">
  <div class="monitor-dashboard-panel-row">
    <div class="w-100">
      <k-p-i-cards ref="kpiCards" :filter="filter"></k-p-i-cards>
    </div>

    <div class="monitor-dashboard-panel-item">
      <all-requests-chart ref="allRequestsChart" :filter="filter"></all-requests-chart>
    </div>

    <div class="monitor-dashboard-panel-item">
      <request-timeline-chart ref="requestTimelineChart" :filter="filter"></request-timeline-chart>
    </div>

    <div class="monitor-dashboard-panel-item">
      <timeline-by-customer-type-chart ref="timelineByCustomerTypeChart" :filter="filter"></timeline-by-customer-type-chart>
    </div>

    <div class="monitor-dashboard-panel-item">
      <delayed-requests-chart ref="delayedRequestsChart" :filter="filter" :tenants="tenants"></delayed-requests-chart>
    </div>
  </div>
</div>